module.exports = __webpack_public_path__ + "static/boggle-06fde03860ff7a23b23d7fb405c11ebe.jpeg";